import React from 'react'
import { Box, Heading, Tag, Wrap, WrapItem } from '@chakra-ui/react'
import { ResearchTag } from '../../types/Research'
import { getTagNames } from '../../utils/researchHelpers'

interface ResearchTagListProps {
  tagIds: string[]
  tags: ResearchTag[]
  title?: string
  size?: 'sm' | 'md' | 'lg'
  colorScheme?: string
  variant?: string
}

const ResearchTagList: React.FC<ResearchTagListProps> = ({
  tagIds,
  tags,
  title = 'Topics',
  size = 'lg',
  colorScheme = 'blue',
  variant = 'subtle',
}) => {
  if (tagIds.length === 0) return null

  const tagNames = getTagNames(tagIds, tags)

  return (
    <Box>
      {title && (
        <Heading size='md' mb={3}>
          {title}
        </Heading>
      )}
      <Wrap>
        {tagNames.map((tagName, index) => (
          <WrapItem key={index}>
            <Tag size={size} colorScheme={colorScheme} variant={variant}>
              {tagName}
            </Tag>
          </WrapItem>
        ))}
      </Wrap>
    </Box>
  )
}

export default ResearchTagList
